const JSolMain = () => {
  return <div>JSolMain</div>;
};

export default JSolMain;
